import { permisosPrueba, COPY_PA3 } from "../lib/pruebaGratis";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { wizardActivo, COPY_WIZARD } from "../lib/wizard";

// Textos propuestos; pendientes de aprobación de Jesús. Fuente única para cambiarlos.
export const COPY_VIGENCIA = {
  titulo: "Tu plan no está vigente",
  motivos: {
    impago: "No pudimos cobrar tu plan. Actualiza tu forma de pago para seguir usando Surit Clínicas.",
    prueba_terminada: "Tu prueba gratuita terminó. Activa tu plan para seguir usando Surit Clínicas.",
    cancelada: "Activa tu plan para seguir usando Surit Clínicas.",
    sin_plan: "Activa tu plan para seguir usando Surit Clínicas.",
  },
  comun: "Tus pacientes, citas y reportes siguen guardados.",
  activar: "Activar plan",
  reportes: "Descargar reportes",
  gracia: (fecha) => `No pudimos cobrar tu plan. Actualiza tu forma de pago antes del ${fecha} para no perder el acceso.`,
};

export function PlanVigenteGuard({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const exceptuada = ["/app/onboarding", "/app/reportes"].includes(pathname.replace(/\/$/, ""));
  const permisos = permisosPrueba(user);
  if (permisos?.puede_configurar && !permisos.puede_operar && !user?.is_demo_session) {
    if (["/app/doctores", "/app/asistente", "/app/perfil", ...(wizardActivo(user) ? ["/app/configurar"] : [])].includes(pathname.replace(/\/$/, "")) || exceptuada) return children;
    return <main className="p-6"><h1>{COPY_PA3.configurar}</h1>
      <div className="mt-4 flex gap-4"><Link to="/app/doctores">{COPY_PA3.medicos}</Link><Link to="/app/asistente">{COPY_PA3.sofi}</Link></div>
      {wizardActivo(user) && <Link to="/app/configurar">{COPY_WIZARD.retomar}</Link>}
    </main>;
  }
  if (user?.is_demo_session || (permisos ? permisos.puede_operar : user?.plan_vigente?.vigente !== false) || exceptuada) return children;
  return (
    <main className="min-h-screen bg-brand-bg grid place-items-center p-6">
      <section aria-labelledby="vigencia-titulo" className="max-w-lg rounded-xl bg-white p-8 shadow">
        <h1 id="vigencia-titulo" className="text-2xl font-bold">{COPY_VIGENCIA.titulo}</h1>
        <p className="mt-4">{COPY_VIGENCIA.motivos[user.plan_vigente.motivo] || COPY_VIGENCIA.motivos.sin_plan}</p>
        <p className="mt-4">{COPY_VIGENCIA.comun}</p>
        <div className="mt-6 flex flex-wrap gap-4">
          <Link className="rounded-lg bg-brand-electric text-white px-4 py-2" to="/app/onboarding">{COPY_VIGENCIA.activar}</Link>
          <Link className="rounded-lg border px-4 py-2" to="/app/reportes">{COPY_VIGENCIA.reportes}</Link>
        </div>
      </section>
    </main>
  );
}

export function AvisoGracia() {
  const { user } = useAuth();
  const estado = user?.plan_vigente;
  if (user?.is_demo_session || estado?.vigente !== true || estado?.motivo !== "gracia_pago" || !estado.hasta) return null;
  // Una fecha civil ISO sin hora se conserva sin desplazarla por la zona del navegador.
  const fecha = new Date(estado.hasta.length === 10 ? `${estado.hasta}T12:00:00-06:00` : estado.hasta);
  if (Number.isNaN(fecha.getTime())) return null;
  const texto = fecha.toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric", timeZone: "America/Mexico_City" });
  return <div role="status" className="bg-amber-50 text-amber-900 px-6 py-3">{COPY_VIGENCIA.gracia(texto)} <Link className="underline" to="/app/onboarding">{COPY_VIGENCIA.activar}</Link></div>;
}
